import { securityKey } from "../../../data/SecurityKey";
import { AppIcons } from "../../../data/appIcons";

export const Menu = [
  // {
  //   groupLabel: "MAIN",
  // },
  {
    id: "dashboard",
    menuTitle: "Dashboard",
    navigationPath: "/Dashboard",
    menuKey: 1,
    iconifyIcon: "ri:apps-2-line",
    securityParentMenuKey: null,
    children: null,
    securityKey: securityKey.COMMONPAGE,
  },
  {
    id: "",
    menuTitle: "My Projects",
    navigationPath: "/myprojects",
    menuKey: 2,
    iconifyIcon: "material-symbols:folder-copy-outline",
    securityParentMenuKey: null,
    children: null,
    securityKey: securityKey.COMMONPAGE,
  },
  {
    id: "",
    menuTitle: "My Team",
    navigationPath: "/myteams",
    menuKey: 3,
    iconifyIcon: "fluent:people-team-32-regular",
    securityParentMenuKey: null,
    children: null,
    securityKey: securityKey.COMMONPAGE,
  },
  // {
  //   id: "",
  //   menuTitle: "Team Overview",
  //   navigationPath: "/teamOverview",
  //   menuKey: 4,
  //   iconifyIcon: "fluent:shifts-team-24-regular",
  //   securityParentMenuKey: null,
  //   children: null,
  //   securityKey: securityKey.COMMONPAGE,
  // },
  // {
  //   id: "",
  //   menuTitle: "Project Overview",
  //   navigationPath: "/projectOverview",
  //   menuKey: 9,
  //   iconifyIcon: "fluent:shifts-team-24-regular",
  //   securityParentMenuKey: null,
  //   children: null,
  //   securityKey: securityKey.COMMONPAGE,
  // },
  // {
  //   groupLabel: "MANAGEMENT",
  // },
  // {
  //   id: "userManagement",
  //   menuTitle: "User Management",
  //   menuKey: 4,
  //   iconifyIcon: "mi:users",
  //   navigationPath: "/users",
  //   securityParentMenuKey: null,
  // },
  // {
  //   id: "projectManagement",
  //   menuTitle: "Project Management",
  //   iconifyIcon: "si:projects-line",
  //   navigationPath: "/projects",
  //   menuKey: 5,
  //   securityParentMenuKey: null,
  //   subSidebarChildren: [
  //     {
  //       id: "project",
  //       subMenuName: "Project",
  //       navigationPath: "/projects",
  //       iconifyIcon: "mdi:folder-outline",
  //     },
  //   ],
  // },
  {
    id: "timeSheet",
    menuTitle: "Time Sheet",
    navigationPath: "#",
    menuKey: 6,
    iconifyIcon: "tdesign:time",
    securityParentMenuKey: null,
    isAdmin: true,
    securityKey: securityKey.COMMONPAGE,
    children: [
      {
        id: "myTimeSheet",
        subMenuName: "My Time sheet",
        navigationPath: "/TimeSheet/MyTimeSheet",
        securityKey: securityKey.COMMONPAGE,
      },
      {
        id: "timeSheetLog",
        subMenuName: "Time Sheet Log",
        navigationPath: "/TimeSheet/TimeSheetLog",
        securityKey: securityKey.COMMONPAGE,
      },
      {
        id: "reviewTimeSheet",
        subMenuName: "Review Time Sheet",
        navigationPath: "/TimeSheet/ReviewTimeSheet",
        securityKey: securityKey.REVIEWTIMESHEET,
      },
      {
        id: "timeSheetlist",
        subMenuName: "Timesheet Report",
        navigationPath: "TimeSheet/reports",
        securityKey: securityKey.REVIEWTIMESHEET,
      }
    ],
  },
  // {
  //   id: "",
  //   menuTitle: "Task Layout",
  //   navigationPath: "/tasklayout",
  //   menuKey: 5,
  //   iconifyIcon: "mingcute:layout-line",
  //   securityParentMenuKey: null,
  //   children: null,
  //   securityKey: securityKey.COMMONPAGE,
  // },
  {
    id: "multiRowGroupFormPage",
    menuKey: 6,
    iconifyIcon: "pixelarticons:article-multiple",
    menuTitle: "Row Group Form Page",
    navigationPath: "/nestedTableTestPage",
    securityParentMenuKey: securityKey.COMMONPAGE,
  },
  // {
  //   id: "",
  //   menuTitle: "Project Overview",
  //   navigationPath: "/projectOverview",
  //   menuKey: 9,
  //   iconifyIcon: "fluent:shifts-team-24-regular",
  //   securityParentMenuKey: null,
  //   children: null,
  //   securityKey: securityKey.PROJECTDETAILS,
  // },
  // {
  //   id: "editmytask",
  //   menuTitle: "Edit Task",
  //   navigationPath: "/EditMyTask/:id",
  //   menuKey: 7,
  //   iconifyIcon: "fluent:task-list-ltr-24-filled",
  //   securityParentMenuKey: null,
  //   children: null,
  //   securityKey: securityKey.COMMONPAGE,
  // },

  // {
  //   id: "TeamsManagement",
  //   menuTitle: "Team Management",
  //   menuKey: 9,
  //   iconifyIcon: "fluent:people-team-toolbox-20-regular",
  //   navigationPath: "/teams",
  //   securityParentMenuKey: null,
  // }, 
  // {
  //   groupLabel: "GENERAL",
  // },
  // {
  //   id: "calendar",
  //   menuTitle: "calendar",
  //   menuKey: 10,
  //   iconifyIcon: "iconoir:calendar",
  //   navigationPath: "/calendar",
  //   securityParentMenuKey: null,
  // },
  // {
  //   id: "multiRowFormPage",
  //   menuKey: 11,
  //   iconifyIcon: "fluent:form-28-regular",
  //   menuTitle: "Multi Row Form Creator",
  //   navigationPath: "/MultiRowFormPage",
  //   securityParentMenuKey: null,
  // },
  // {
  //   id: "multiRowGroupFormPage",
  //   menuKey: 12,
  //   iconifyIcon: "pixelarticons:article-multiple",
  //   menuTitle: "Row Group Form Page",
  //   navigationPath: "/MultiRowGroupFormPage",
  //   securityParentMenuKey: null,
  // },
  // {
  //   id: "TeamUser",
  //   menuTitle: "Team User",
  //   menuKey: 11,
  //   iconifyIcon: "ri:shield-user-line",
  //   navigationPath: "/teamUser",
  //   securityParentMenuKey: null,
  // },


];

export const TeamsMenu = [
  {
    groupLabel: "TEAMS",
  },
  {
    id: "TeamDetails",
    menuTitle: "Team Details",
    menuKey: 1,
    iconifyIcon: "ri:shield-user-line",
    navigationPath: "/admin/teams/EditTeam/:id",
    securityParentMenuKey: null,
    securityKey: securityKey.TEAMDETAILS,
  },
  // {
  //   id: "TeamMemberManagement",
  //   menuTitle: "Team Members Management",
  //   menuKey: 1,
  //   iconifyIcon: "ri:shield-user-line",
  //   navigationPath: "/teams/TeamMembers/",
  //   securityParentMenuKey: null,
  // },
  // {
  //   id: "TeamProject",
  //   menuTitle: "Team Project",
  //   iconifyIcon: "ri:stack-line",
  //   menuKey: 2,
  //   navigationPath: "/teams/TeamProjects/",
  //   securityParentMenuKey: null,
  //   isAdmin: true,
  // },
  {
    id: "teamPlanning",
    menuTitle: "Team Planning",
    iconifyIcon: "ri:server-line",
    menuKey: 2,
    navigationPath: "/admin/teams/TeamPlanning/:id",
    securityParentMenuKey: null,
    isAdmin: true,
    securityKey: securityKey.TEAMPLANNING,
  },
  {
    id: "Team Board",
    menuTitle: "Team Board",
    iconifyIcon: "gg:board",
    menuKey: 3,
    navigationPath: "/admin/teams/teamBoard/:id",
    securityParentMenuKey: null,
    isAdmin: true,
    securityKey: securityKey.COMMONPAGE,
  },
];

export const ProjectMenu = [
  {
    groupLabel: "PROJECTS",
  },
  {
    id: "ProjectDetails",
    menuTitle: "Project Details",
    navigationPath: "/admin/project/EditProject/:id",
    menuKey: 1,
    // menuIcon: AppIcons.Dashboardblack,
    // menuIconactive: AppIcons.Dashboardwhite,
    iconifyIcon: "material-symbols-light:file-copy-outline",
    securityParentMenuKey: null,
    children: null,
    securityKey: securityKey.COMMONPAGE,
  },
  // {
  //   id: "ProjectTeam",
  //   menuTitle: "Project Team",
  //   navigationPath: "/admin/project/ProjectTeamManagement/:id",
  //   menuKey: 2,
  //   // menuIcon: AppIcons.Usermanagement,
  //   // menuIconactive: AppIcons.Usermanagementwhite,
  //   iconifyIcon: "fluent:people-team-20-regular",
  //   securityParentMenuKey: null,
  //   securityKey: securityKey.PROJECTTEAM,
  // },
  {
    id: "ProjectConfig",
    menuTitle: "Project Config",
    navigationPath: "#",
    menuKey: 3,
    // menuIcon: AppIcons.Projectmanagement,
    // menuIconactive: AppIcons.Projectmanagementactive,
    iconifyIcon: "ph:file-c",
    securityParentMenuKey: null,
    isAdmin: true,
    securityKey: securityKey.PROJECTCONFIG,

    children: [
      {
        id: "ProjectComponent",
        subMenuName: "Project Component",
        navigationPath: "/admin/project/ProjectComponent/:id",
        submenuIcon: AppIcons.Usermanagement,
        securityKey: securityKey.PROJECTCONFIG,
      },
      {
        id: "ProjectModule",
        subMenuName: "Project Module",
        navigationPath: "/admin/project/ProjectModule/:id",
        submenuIcon: AppIcons.Usermanagement,
        securityKey: securityKey.PROJECTCONFIG,
      },

      {
        id: "ProjectVersion",
        subMenuName: "Project Version",
        navigationPath: "/admin/project/ProjectVersion/:id",
        submenuIcon: AppIcons.Usermanagement,
        securityKey: securityKey.PROJECTCONFIG,
      },
      // {
      //   id: "ProjectStatus",
      //   subMenuName: "Project Status",
      //   navigationPath: "/admin/project/ProjectStatus/:id",
      //   submenuIcon: AppIcons.Usermanagement,
      //   securityKey: securityKey.PROJECTCONFIG,
      // },
      {
        id: "ProjectEnvironment",
        subMenuName: "Project Environment ",
        navigationPath: "/admin/project/ProjectEnvironment/:id",
        submenuIcon: AppIcons.Usermanagement,
        securityKey: securityKey.PROJECTCONFIG,
      },
    ],
  },
  {
    id: "ProjectSynergy",
    menuTitle: "Project Synergy",
    navigationPath: "/admin/project/projectSynergy/:id",
    menuKey: 4,
    // menuIcon: AppIcons.Usermanagement,
    // menuIconactive: AppIcons.Usermanagementwhite,
    iconifyIcon: "solar:server-broken",
    securityParentMenuKey: null,
    securityKey: securityKey.COMMONPAGE,
  },
  {
    id: "Backlog",
    menuTitle: "Backlog",
    navigationPath: "/admin/project/BacklogList/:id",
    menuKey: 5,
    // menuIcon: AppIcons.Usermanagement,
    // menuIconactive: AppIcons.Usermanagementwhite,
    iconifyIcon: "solar:server-broken",
    securityParentMenuKey: null,
    securityKey: securityKey.COMMONPAGE,
  },
  {
    id: "TaskBoard",
    menuTitle: "Task Board",
    navigationPath: "/admin/project/ProjectTaskBoard/:id",
    menuKey: 6,
    // menuIcon: AppIcons.Usermanagement,
    // menuIconactive: AppIcons.Usermanagementwhite,
    iconifyIcon: "gg:board",
    securityParentMenuKey: null,
    securityKey: securityKey.COMMONPAGE,
  },
];

export const AdminMenu = [
  {
    groupLabel: "ADMIN",
  },
  {
    id: "Organization",
    menuTitle: "Organization",
    iconifyIcon: "material-symbols:corporate-fare",
    navigationPath: "/admin/Organization",
    menuKey: 1,
    securityKey: securityKey.ADMIN,
  },
  {
    id: "userManagement",
    menuTitle: "User Management",
    menuKey: 2,
    iconifyIcon: "mi:users",
    navigationPath: "/admin/users",
    securityParentMenuKey: null,
    securityKey: securityKey.ADMIN,
  },
  {
    id: "customerManagement",
    menuTitle: "Customer Management",
    iconifyIcon: "formkit:people",
    menuKey: 3,
    navigationPath: "/admin/customers",
    securityKey: securityKey.ADMIN,
  },
  {
    id: "projectManagement",
    menuTitle: "Project Management",
    iconifyIcon: "si:projects-line",
    navigationPath: "admin/projects",
    menuKey: 4,
    securityParentMenuKey: null,
    securityKey: securityKey.PROJECTMANAGEMENT,
  },
  {
    id: "TeamsManagement",
    menuTitle: "Team Management",
    menuKey: 5,
    iconifyIcon: "fluent:people-team-toolbox-20-regular",
    navigationPath: "admin/teams",
    securityParentMenuKey: null,
    securityKey: securityKey.TEAMMANAGEMENT,
  },
  {
    id: "RoleManagement",
    menuTitle: "Role Management",
    navigationPath: "/admin/roles",
    menuKey: 6,
    iconifyIcon: "oui:app-users-roles",
    securityKey: securityKey.ADMIN,
  },

  {
    id: "GroupManagement",
    menuTitle: "Group Management",
    navigationPath: "/admin/groups",
    menuKey: 7,
    iconifyIcon:"fluent:people-team-toolbox-20-regular",
    securityParentMenuKey: null,
    children: null,
    securityKey: securityKey.ADMIN,
  },

  {
    id: "EmailTemplate",
    menuTitle: "Email Template",
    navigationPath: "/admin/emailTemplates",
    menuKey: 8,
    iconifyIcon: "mdi:email-edit-outline",
    securityKey: securityKey.ADMIN,
  },
  {
    id: "GmailTemplate",
    menuTitle: "Gmail Template",
    navigationPath: "/admin/gmailTemplates",
    menuKey: 9,
    iconifyIcon: "mdi:email-edit-outline",
    securityKey: securityKey.ADMIN,
  },
  {
    id: "ProjectSettings",
    menuTitle: "Project Settings",
    navigationPath: "#",
    menuKey: 10,
    // menuIcon: AppIcons.Projectmanagement,
    // menuIconactive: AppIcons.Projectmanagementactive,
    iconifyIcon: "ph:file-c",
    securityParentMenuKey: null,
    isAdmin: true,
    securityKey: securityKey.PROJECTCONFIG,

    children: [
      {
        id: "ProjectType",
        subMenuName: "Project Type",
        navigationPath: "/admin/projectsettings/ProjectType",
        submenuIcon: AppIcons.Usermanagement,
        securityKey: securityKey.PROJECTCONFIG,
      },

      {
        id: "ProjectDomain",
        subMenuName: "Project Domain",
        navigationPath: "/admin/projectSettings/ProjectDomain",
        submenuIcon: AppIcons.Usermanagement,
        securityKey: securityKey.PROJECTCONFIG,
      },

      {
        id: "SourceControl",
        subMenuName: "Source Control",
        navigationPath: "/admin/projectSettings/sourceControl",
        submenuIcon: AppIcons.Usermanagement,
        securityKey: securityKey.PROJECTCONFIG,
      },
    ],
  },
  {
    id: "StatusCategories",
    menuTitle: "Status Categories",
    navigationPath: "/admin/StatusCategories",
    menuKey: 11,
    iconifyIcon: "mdi:tag-multiple-outline",
    securityKey: securityKey.ADMIN,
  },
  {
    id: "PlanningStatus",
    menuTitle: "Planning Status",
    navigationPath: "/admin/PlanningStatus",
    menuKey: 12,
    iconifyIcon: "carbon:task-view",
    securityKey: securityKey.ADMIN,
  },
  {
    id: "reports",
    menuTitle: "Reports",
    navigationPath: "#",
    menuKey: 13,
    iconifyIcon: "tdesign:time",
    securityParentMenuKey: null,
    isAdmin: true,
    securityKey: securityKey.ADMIN,
    children: [
      {
        id: "timesheetReports",
        subMenuName: "Time Sheet Reports",
        navigationPath: "/admin/reports/TimeSheetReports",
        securityKey: securityKey.ADMIN,
      },
      {
        id: "groupWiseReports",
        subMenuName: "Group Wise Reports",
        navigationPath: "/admin/reports/GroupWiseReports",
        securityKey: securityKey.ADMIN,
      },
    ]
  },
  {
    id: "employeeaudit",
    menuTitle: "Employee Audit",
    navigationPath: "#",
    menuKey: 14,
    iconifyIcon: "hugeicons:audit-01",
    securityParentMenuKey: null,
    isAdmin: true,
    securityKey: securityKey.ADMIN,
    children: [
      {
        id: "TimesheetReports",
        subMenuName: "Timesheet Reports",
        navigationPath: "/admin/employee/TimesheetReports",
        securityKey: securityKey.ADMIN,
      },
      {
        id: "audit",
        subMenuName: "Audit",
        navigationPath: "/admin/employee/Audit",
        securityKey: securityKey.ADMIN,
      },
    ]
  }
];

export const MyProjectMenu = [
  {
    groupLabel: "MY PROJECTS",
  },
  {
    id: "",
    menuTitle: "My Tasks",
    iconifyIcon: "fluent:clipboard-task-list-ltr-20-regular",
    navigationPath: "/myprojects/tasklist/:id",
    menuKey: 1,
    securityKey: securityKey.COMMONPAGE,
  },
  {
    id: "ProjectDetails",
    menuTitle: "Project Details",
    navigationPath: "/myprojects/EditProject/:id",
    menuKey: 2,
    // menuIcon: AppIcons.Dashboardblack,
    // menuIconactive: AppIcons.Dashboardwhite,
    iconifyIcon: "material-symbols-light:file-copy-outline",
    securityParentMenuKey: null,
    children: null,
    securityKey: securityKey.PROJECTDETAILS,
  },
  // {
  //   id: "ProjectTeam",
  //   menuTitle: "Project Team",
  //   navigationPath: "/myprojects/ProjectTeamManagement/:id",
  //   menuKey: 3,
  //   iconifyIcon: "fluent:people-team-20-regular",
  //   securityParentMenuKey: null,
  //   securityKey: securityKey.PROJECTTEAM,
  // },

  {
    id: "",
    menuTitle: "Backlog Tasks",
    // iconifyIcon: "stash:list-add",
    // iconifyIcon: "fluent-mdl2:backlog-list",
    iconifyIcon: "stash:list-add",
    menuKey: 5,
    navigationPath: "/myprojects/backlog/:id",
    securityKey: securityKey.COMMONPAGE,
  },
  {
    id: "",
    menuTitle: "Planned Tasks",
    // iconifyIcon: "stash:list-add",
    iconifyIcon: "fluent:board-split-20-regular",
    menuKey: 6,
    navigationPath: "/myprojects/projecttaskboard/:id",
    securityKey: securityKey.COMMONPAGE,
  },
  {
    id: "",
    menuTitle: "All Tasks",
    // iconifyIcon: "stash:list-add",
    iconifyIcon: "fluent:board-split-20-regular",
    menuKey: 7,
    navigationPath: "/myprojects/AllTask/:id",
    securityKey: securityKey.COMMONPAGE,
  },
  {
    id: "ProjectConfig",
    menuTitle: "Project Config",
    navigationPath: "#",
    menuKey: 4,
    iconifyIcon: "ph:file-c",
    securityParentMenuKey: null,
    isAdmin: true,
    securityKey: securityKey.PROJECTCONFIG,

    children: [
      {
        id: "ProjectComponent",
        subMenuName: "Project Component",
        navigationPath: "/myprojects/ProjectComponent/:id",
        submenuIcon: AppIcons.Usermanagement,
        securityKey: securityKey.PROJECTCONFIG,
      },
      {
        id: "Project Module",
        subMenuName: "Project Module",
        navigationPath: "/myprojects/ProjectModule/:id",
        submenuIcon: AppIcons.Usermanagement,
        securityKey: securityKey.PROJECTCONFIG,
      },

      {
        id: "ProjectVersion",
        subMenuName: "Project Version",
        navigationPath: "/myprojects/ProjectVersion/:id",
        submenuIcon: AppIcons.Usermanagement,
        securityKey: securityKey.PROJECTCONFIG,
      },
      {
        id: "ProjectEnvironment",
        subMenuName: "Project Environment ",
        navigationPath: "/myprojects/ProjectEnvironment/:id",
        submenuIcon: AppIcons.Usermanagement,
        securityKey: securityKey.PROJECTCONFIG,
      },
    ],
  },
  {
    id: "ProjectSynergy",
    menuTitle: "Project Synergy",
    navigationPath: "/myprojects/projectSynergy/:id",
    menuKey: 8,
    // menuIcon: AppIcons.Usermanagement,
    // menuIconactive: AppIcons.Usermanagementwhite,
    iconifyIcon: "solar:server-broken",
    securityParentMenuKey: null,
    securityKey: securityKey.COMMONPAGE,
  },
];

export const MyTeamsMenu = [
  {
    groupLabel: "MY TEAMS",
  },
  {
    id: "",
    menuTitle: "Team Overview",
    navigationPath: "/myteams/teamOverview/:id",
    menuKey: 1,
    iconifyIcon: "fluent:shifts-team-24-regular",
    securityParentMenuKey: null,
    children: null,
    // Prefer securityKey.TEAMOVERVIEW after permission seed; COMMONPAGE until then.
    securityKey: securityKey.COMMONPAGE,
  },
  {
    id: "myTask",
    menuTitle: "My Tasks",
    iconifyIcon: "fluent:clipboard-task-list-ltr-20-regular",
    navigationPath: "/myteams/teamtasks/:id",
    menuKey: 2,
    securityKey: securityKey.COMMONPAGE,
  },
  {
    id: "TeamDetails",
    menuTitle: "Team Details",
    menuKey: 9,
    iconifyIcon: "ri:shield-user-line",
    navigationPath: "/myteams/EditTeam/:id",
    securityParentMenuKey: null,
    securityKey: securityKey.TEAMDETAILS,
  },
  {
    id: "",
    menuTitle: "Team Planning",
    iconifyIcon: "material-symbols-light:event-note-outline-rounded",
    navigationPath: "/myteams/TeamPlanning/:id",
    menuKey: 3,
    securityKey: securityKey.TEAMPLANNING,
  },
  {
    id: "",
    menuTitle: "Planned Tasks",
    iconifyIcon: "material-symbols-light:team-dashboard-outline-sharp",
    navigationPath: "/myteams/teamboard/:id",
    menuKey: 4,
    securityKey: securityKey.COMMONPAGE,
  },
  // {
  //   id: "",
  //   menuTitle: "Team Work Review",
  //   iconifyIcon: "material-symbols-light:rate-review-outline-sharp",
  //   menuKey: 5,
  //   navigationPath: "/myteams/review/:id",
  //   securityKey: securityKey.COMMONPAGE,
  // },

]
